module.exports = __webpack_public_path__ + "img/icon_stage_outlined_w.210698d4.svg";